import { useState } from 'react'
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { Loading } from 'src/components'
import { Icon } from 'src/components'
import useRequest from 'src/hook/useRequest'
import { PublicationEndpoints } from 'src/client/publication/constants'
import { getPostImage } from 'src/client/publication'
import { NoImage } from 'src/components/noImage'
import { useUser } from 'src/hook/useUser'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { Wrapper as LoaderWrapper } from '../postImage/postImage.styles'
import { getImageDimensions } from '../postImage/postImage.utils'
import { PostVideoProps } from './postVideo.types'
import { REQUEST_CONFIG } from './postVideo.constants'
import { PlayWrapper, Wrapper } from './postVideo.styles'

const PostVideo = ({ post, aspectRatio, isEdit = false }: PostVideoProps) => {
  const [emptyImage, setEmptyImage] = useState(false)
  const { authStatus } = useUser()

  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED
  const url = isUnauthenticated
    ? PublicationEndpoints.getPublicPostImage(post.id)
    : PublicationEndpoints.getPostImage(post.id)

  const {
    data: src,
    isError,
    isLoading
  } = useRequest(
    url,
    /* istanbul ignore next */
    () =>
      getPostImage({
        publicationId: post.id,
        imageDimension: getImageDimensions({
          mediaWidth: post.mediaWidth,
          mediaHeight: post.mediaHeight
        }),
        isUnauthenticated
      }),
    REQUEST_CONFIG
  )

  if (isLoading) {
    return (
      <LoaderWrapper data-test="post-video">
        <Loading full />
      </LoaderWrapper>
    )
  }

  if (isError) {
    return null
  }

  return (
    <Wrapper
      data-test="post-video"
      className="_bg-gray-100"
      $isEdit={isEdit}
      $aspectRatio={aspectRatio}
    >
      <PlayWrapper className="_d-flex _align-items-center _justify-content-center _bg-gray-100 _position-absolute _rounded-lg">
        <Icon icon={faPlay} className="_text-gray-900" size="lg" />
      </PlayWrapper>

      {emptyImage ? (
        <NoImage className="_w-full _h-full" />
      ) : (
        <img src={src} alt={post.title} loading="lazy" onError={() => setEmptyImage(true)} />
      )}
    </Wrapper>
  )
}

export default PostVideo
